import type { RouteObject } from 'react-router';
import { page } from '@/lib/lazy-route';

// Phase B integrations (B9/B10). Settings pages are mounted by the admin layout
// (modules/admin/routes.tsx); this module has no top-level pages of its own.
export const settingsRoutes: RouteObject[] = [
  { path: 'import', lazy: page(() => import('./import-page'), (m) => m.ImportPage) },
  { path: 'microsoft-365', lazy: page(() => import('./m365-settings-page'), (m) => m.M365SettingsPage) },
  // F3 (chat track): Slack & Teams. Also Slack's OAuth redirect URL.
  { path: 'chat', lazy: page(() => import('./chat-settings-page'), (m) => m.ChatSettingsPage) },
  // Phase K (J9): warranty lookup credentials and the nightly refresh.
  { path: 'warranty', lazy: page(() => import('./warranty-settings-page'), (m) => m.WarrantySettingsPage) },
  // K1 (Phase K): SMS (Twilio) and PagerDuty.
  { path: 'alerting', lazy: page(() => import('./alerting-settings-page'), (m) => m.AlertingSettingsPage) },
  // K-1 (B11): Denwen RMM connection, customer mapping and unmapped devices.
  { path: 'denwen-rmm', lazy: page(() => import('./denwen-rmm/settings-page'), (m) => m.RmmSettingsPage) },
  { path: 'denwen-rmm/mapping', lazy: page(() => import('./denwen-rmm/mapping-page'), (m) => m.RmmMappingPage) },
  { path: 'denwen-rmm/devices', lazy: page(() => import('./denwen-rmm/mapping-page'), (m) => m.RmmHeldDevicesPage) },
  { path: 'denwen-rmm/connect', lazy: page(() => import('./denwen-rmm/connect-tab'), (m) => m.RmmConnectPage) }, // K-2 (B12) K2-A
  // K-3 (contract 1.3.0 §17, J1): credential injection settings and the grants report.
  { path: 'denwen-rmm/credentials', lazy: page(() => import('./denwen-rmm/credentials-tab'), (m) => m.RmmCredentialsPage) },
  { path: 'denwen-rmm/credentials/injections', lazy: page(() => import('./denwen-rmm/credential-injections-page'), (m) => m.RmmCredentialInjectionsPage) },
  // J6 / J7 (contract 1.4.0 §19–§20): tray help requests and the portal link.
  { path: 'denwen-rmm/tray', lazy: page(() => import('./denwen-rmm/tray-tab'), (m) => m.RmmTrayPage) },
  // D5b (contract 1.5.0 §21): BitLocker recovery keys from Denwen RMM into the vault.
  { path: 'denwen-rmm/bitlocker', lazy: page(() => import('./denwen-rmm/bitlocker-tab'), (m) => m.RmmBitLockerPage) },
];

export const routes: RouteObject[] = [];
/** The M365 and Devices tabs inside an organization. */
export const orgRoutes: RouteObject[] = [
  { path: 'm365', lazy: page(() => import('./org-m365'), (m) => m.OrgM365Page) },
  // K-1 (B11): Denwen RMM devices are configurations; the old Devices address opens them there.
  { path: 'devices', lazy: page(() => import('./denwen-rmm/org-devices'), (m) => m.OrgDevicesRedirect) },
];
